import React from 'react'
import Cards from './Cards'
import './Css/hero.css'

export default function Hero() {
  return (
    <>
      <div className="hero-container">
        <div className='hero-div'>
          <img
            src="\images\BES_HERO_with_bg_Quote.png"
            alt=""
            className="hero-img-f"
          />
        </div>
        <Cards />
      </div>
    </>
  );
}
